import React, { useEffect, useState } from "react"
import { Card, CardBody, CardTitle, Col, Container, Row } from "reactstrap"

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"

//Import Date Picker
import "react-datepicker/dist/react-datepicker.css"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { connect } from "react-redux"
import {
  buscarAgenda,
  editarRelatorioAgenda
} from "../../store/auth/profile/actions"
import usePermission from "helpers/permission/usePermission"
import { navegarBreadCrumb } from "../../store/navigator/actions"
import Loader from "react-loader-spinner"
import { withTranslation } from "react-i18next"
import { Link, withRouter } from "react-router-dom"
import { isEmpty, map } from "lodash"
import RelatoriosAgendadosModal from "./relatorios-agendados-modal"

const RelatoriosAgendadosLista = props => {
  const [tarefasAgendadas, setTarefasAgendadas] = useState([])
  const [modal, setModal] = useState(false)
  const [tarefaAgendada, setTarefaAgendada] = useState({id: null, hora: null, tipo: 1})
  const usePermissionEdit = usePermission('relatoriosAgendados_editar')

  useEffect(() => {
    props.buscarAgenda()
    props.navegarBreadCrumb( {title: `breadcrumb.schedule.title`, link: `/relatorios-agendados`})
  }, [])


  useEffect(() => {
    if(props.relatorioAgenda) {
      setTarefasAgendadas(props.relatorioAgenda)
    }
  }, [props.relatorioAgenda])

  const salvar = (tarefa) => {
    props.editarRelatorioAgenda(tarefa)
    toggle()
  }

  const toggleModal = item => {
    setTarefaAgendada(item)
    setModal(!modal)
  }

  const toggle = () => {
    setModal(!modal)
  }

  const describeTipo = tipo => {
    if (tipo === null) {
      return "N/D"
    } else {
      return props.t(`company-report.tipo.${tipo}`)
    }
  }

  const describeHour = (hour) => {
    if (hour === undefined) {
      return "N/D";
    }
    return hour.slice(0,5)
  };

  return props.relatorioAgendaLoading ? (
      <div className="loader-container">
        <Loader type="ThreeDots" color="#556EE6" height={ 80 } width={ 80 } />
      </div>
    ) : (
    <>
      <div className="page-content">

        <Container fluid>
          {/* Render Breadcrumbs */ }
          <Breadcrumbs title='breadcrumb.schedule.title' />

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">{props.t("menu.label.scheduled-reports")}</CardTitle>

                  <div className="table-responsive">
                    <table
                      className="dataTable table table-bordered table-striped table-nowrap table-centered mb-0 table-hover">
                      <thead>
                      <tr>
                        <th>{props.t("company-report.tipo")}</th>
                        <th>{props.t("scheduled-reports.hour")}</th>
                        <th>{props.t("label.actions")}</th>
                      </tr>
                      </thead>

                      <tbody>
                      { (isEmpty(tarefasAgendadas) && (
                          <tr>
                            <td>
                              <h5 className="text-truncate font-size-14 m-0">
                                {props.t("scheduled-reports.no.data")}
                              </h5>
                            </td>
                          </tr>
                        )) ||
                        map(tarefasAgendadas, (item, i) => (
                          <tr key={ i }>
                            <td className="text-truncate text-dark">
                              { describeTipo(item.tipo) }
                            </td>
                            <td className="text-truncate text-dark">
                              { describeHour(item.hora) }
                            </td>
                            <td>
                              { usePermissionEdit &&
                                <Link to="#" className="me-3 text-primary">
                                  <i
                                    className="mdi mdi-pencil font-size-18 me-3"
                                    id="edittooltip"
                                    onClick={ e => toggleModal(item) }
                                    title={props.t("scheduled-reports.edit")}
                                  />
                                </Link>
                              }
                            </td>
                          </tr>
                        )) }
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <RelatoriosAgendadosModal
        relatorioAgendado={ tarefaAgendada }
        isOpen={ modal }
        toggle={ toggle }
        saveRelatorioAgendado={ salvar }
      />
    </>
    )
}

const mapStatetoProps = state => {
  const { relatorioAgenda, relatorioAgendaLoading } = state.Profile
  return { relatorioAgenda, relatorioAgendaLoading }
}

export default withTranslation()(connect(mapStatetoProps, {
  navegarBreadCrumb,
  buscarAgenda,
  editarRelatorioAgenda
})(withRouter(RelatoriosAgendadosLista)))
